import stickyFocus from '@switch-company/sticky-focus';

new stickyFocus({
  elements: Array.prototype.slice.call(document.querySelectorAll( '.site-banner, .intro-banner, .intro-action' )),
  padding: 10
});
